import request from '../../../utils/Request';
import { Methods } from '../../../config';

const baseURL = 'delVill/taskResourcePlanner';

const dvTaskResourcePlannerService = {
  getTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task`,
      data,
    });
  },

  copyAndCreateTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/copyAndCreate`,
      data,
    });
  },

  copyTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/copies`,
      data,
    });
  },

  moveTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/move`,
      data,
    });
  },

  getResources: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/resources`,
      data,
    });
  },

  updateTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  searchTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },

  deleteTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task/delete`,
      data,
    });
  },
};
export default dvTaskResourcePlannerService;
